export default __webpack_public_path__ + "static/media/digifinex.72f2bc40.svg";